import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@crystal/core";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import { getGlobalThis } from "../store/utils.js";
const EXT_AUTH_FLOW_KEY = "account-ext-auth-flow";
const EXT_AUTH_DATA_KEY = "account-ext-auth-data";
const LEGACY_CHECKOUT_REDIRECT_TARGET_KEY = "glass-social-login-redirect-target";
const LEGACY_GLASS_REDIRECT_TARGET_KEY = "glass-ext-auth-initiator";
const LEGACY_GLASS_METHOD_KEY = "glass-ext-auth-method";
const LEGACY_GLASS_INTEND_KEY = "glass-ext-auth-intend";
const LEGACY_GLASS_PERSISTENT_LOGIN_KEY = "persistentLoginConsent";
function hasExternalAuthData() {
  return hasItem(EXT_AUTH_FLOW_KEY) || hasItem(LEGACY_GLASS_REDIRECT_TARGET_KEY) || hasItem(LEGACY_CHECKOUT_REDIRECT_TARGET_KEY);
}
function saveAuthFlow(flow) {
  setItem(EXT_AUTH_FLOW_KEY, JSON.stringify(flow));
}
function retrieveAuthFlow() {
  return getItem(EXT_AUTH_FLOW_KEY);
}
function saveExternalAuthData({ authContext, pageContext, error }) {
  setItem(
    EXT_AUTH_DATA_KEY,
    JSON.stringify({
      authContext,
      pageContext,
      error
    })
  );
}
function retrieveExternalAuthData() {
  return hasItem(EXT_AUTH_DATA_KEY) ? getItem(EXT_AUTH_DATA_KEY) : void 0;
}
function retrieveLegacyRedirectRoute() {
  if (hasItem(LEGACY_CHECKOUT_REDIRECT_TARGET_KEY)) {
    return getItem(LEGACY_CHECKOUT_REDIRECT_TARGET_KEY);
  }
  if (hasItem(LEGACY_GLASS_REDIRECT_TARGET_KEY)) {
    return getItem(LEGACY_GLASS_REDIRECT_TARGET_KEY);
  }
  return null;
}
function retrieveLegacyMethod() {
  if (hasItem(LEGACY_GLASS_METHOD_KEY)) {
    return getItem(LEGACY_GLASS_METHOD_KEY, { rawValue: true });
  }
  return null;
}
function retrieveLegacyPersistentLogin() {
  if (hasItem(LEGACY_GLASS_PERSISTENT_LOGIN_KEY)) {
    return getItem(LEGACY_GLASS_PERSISTENT_LOGIN_KEY);
  }
  return false;
}
function removeAuthFlow() {
  const storage = getStorage();
  storage.removeItem(EXT_AUTH_FLOW_KEY);
}
function removeExternalAuthData() {
  const storage = getStorage();
  storage.removeItem(EXT_AUTH_DATA_KEY);
}
function removeLegacyAuthFlow() {
  const storage = getStorage();
  storage.removeItem(LEGACY_CHECKOUT_REDIRECT_TARGET_KEY);
  storage.removeItem(LEGACY_GLASS_REDIRECT_TARGET_KEY);
  storage.removeItem(LEGACY_GLASS_METHOD_KEY);
  storage.removeItem(LEGACY_GLASS_INTEND_KEY);
}
function hasItem(key) {
  return !!getStorage().getItem(key);
}
function setItem(key, value) {
  getStorage().setItem(key, value);
}
function getItem(key, { rawValue = false } = {}) {
  const value = getStorage().getItem(key);
  if (!value) {
    throw Error(`Invalid value. Key: ${key}`);
  }
  if (rawValue) {
    return value;
  }
  try {
    return JSON.parse(value);
  } catch (err) {
    throw Error(`${value} is invalid. Key: ${key}`);
  }
}
function getStorage() {
  const win = getGlobalThis();
  const storage = win.sessionStorage || {
    getItem: () => null,
    setItem: () => void 0
  };
  return storage;
}
export {
  hasExternalAuthData,
  removeAuthFlow,
  removeExternalAuthData,
  removeLegacyAuthFlow,
  retrieveAuthFlow,
  retrieveExternalAuthData,
  retrieveLegacyMethod,
  retrieveLegacyPersistentLogin,
  retrieveLegacyRedirectRoute,
  saveAuthFlow,
  saveExternalAuthData
};
//# sourceMappingURL=persistence.js.map
